import React, {useState} from 'react';
import OverlayWithSpinner from './OverlayWithSpinner.tsx';
import {useConfirm} from '../ds/confirmContext.ts';

interface ConfirmActionButtonProps {
    id: string;
    cssClass: string;
    buttonText: string;
    // The question the dialog asks: 'Archive #general?'
    confirmationMessage: string;
    // What happens if they go ahead.
    body?: React.ReactNode;
    confirmLabel?: string;
    safeLabel?: string;
    // Off for confirmations that aren't destructive.
    danger?: boolean;
    typeToConfirm?: string;
    onClickAction: (
        event: React.MouseEvent<HTMLButtonElement>
    ) => Promise<void> | void;
}

const ConfirmActionButton: React.FC<ConfirmActionButtonProps> = ({
    id,
    cssClass,
    buttonText,
    confirmationMessage,
    body,
    confirmLabel,
    safeLabel,
    danger = true,
    typeToConfirm,
    onClickAction
}) => {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const confirm = useConfirm();

    const confirmAction = async (
        event: React.MouseEvent<HTMLButtonElement>
    ) => {
        const confirmed = await confirm({
            title: confirmationMessage,
            body,
            confirmLabel: confirmLabel ?? buttonText,
            safeLabel,
            danger,
            typeToConfirm
        });
        if (confirmed) {
            const result = onClickAction(event);

            if (result instanceof Promise) {
                setIsSubmitting(true);
                try {
                    await result;
                } finally {
                    setIsSubmitting(false);
                }
            }
        }
    };

    return (
        <>
            <button
                type="button"
                id={id}
                className={cssClass}
                title={buttonText}
                aria-label={buttonText}
                onClick={confirmAction}
            >
                {buttonText}
            </button>
            {isSubmitting && <OverlayWithSpinner />}
        </>
    );
};

export default ConfirmActionButton;
